import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';
import { CloverThemeProvider } from 'shamrock-clover-ui';
import 'shamrock-clover-ui/dist/clover/css/clover.css';
import App from './App';
import './i18n';
import './index.scss';
import store from './store';
import { DriftThemeProvider } from 'drift-ui';
import { initPostHog } from './posthog';

Sentry.init({
  dsn: config.sentryDSN,
  environment: config.sentryEnvironment,
  sendDefaultPii: true,
});

const container = document.getElementById('app');
const root = createRoot(container as HTMLElement);
export default function bootstrap() {
  initPostHog();
  root.render(
    <Auth0Provider
      domain={config.auth0CustomDomain}
      clientId={config.auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${config.auth0Domain}/api/v2/`,
        scope: 'openid profile email offline_access',
      }}
    >
      <Provider store={store}>
        <CloverThemeProvider>
          <DriftThemeProvider>
            <App />
          </DriftThemeProvider>
        </CloverThemeProvider>
      </Provider>
    </Auth0Provider>,
  );
}
